import {
  getMyFollowersUrl,
  getMyFollowingUrl,
  getMyProfileUrl,
  getProfileFollowersUrl,
  getProfileFollowingUrl,
  getProfileUrl,
} from '@/presentation/services/urls/profile';
import {
  AllProfileActions,
  ProfileAction,
  ProfileDispatcher,
  ProfileDispatcherPayload,
  ProfilePageAction,
} from '@pelando/components';
import { useRouter } from 'next/router';

export type ProfileCommand = {
  type: AllProfileActions;
  payload: ProfileDispatcherPayload<AllProfileActions>;
};

type ActionsHandlerProps = {
  isOwner?: boolean;
  nickname: string;
  onUpdateAvatar?: ({ file }: { file: File }) => void;
  showUpdateNicknameModal: () => void;
  followUserHandler?: (params: { userId: string }) => void;
  unfollowUserHandler?: (params: { userId: string }) => void;
  showMyDataPage: () => void;
};

const useActionsHandler = ({
  isOwner,
  nickname,
  onUpdateAvatar,
  showUpdateNicknameModal,
  followUserHandler,
  unfollowUserHandler,
  showMyDataPage,
}: ActionsHandlerProps): ProfileDispatcher => {
  const { back, push, locale } = useRouter();

  return (action) => {
    switch (action.type) {
      case ProfileAction.ON_CLICK_FOLLOWERS: {
        const url = isOwner
          ? getMyFollowersUrl(undefined, locale)
          : getProfileFollowersUrl(nickname, undefined, locale);

        push(url);

        break;
      }

      case ProfileAction.ON_CLICK_FOLLOWING: {
        const url = isOwner
          ? getMyFollowingUrl(locale)
          : getProfileFollowingUrl(nickname, locale);

        push(url);
        break;
      }

      case ProfileAction.ON_CLICK_DEALS: {
        const url = isOwner
          ? getMyProfileUrl(undefined, locale)
          : getProfileUrl(nickname, undefined, locale);
        push(url);
        break;
      }

      case ProfilePageAction.ON_GO_BACK:
        back();
        break;

      case ProfileAction.ON_EDIT_AVATAR:
        if (onUpdateAvatar) {
          onUpdateAvatar(
            action.payload as ProfileDispatcherPayload<ProfileAction.ON_EDIT_AVATAR>
          );
        }
        break;

      case ProfileAction.ON_EDIT_NICKNAME:
        showUpdateNicknameModal();
        break;

      case ProfileAction.ON_CLICK_TO_FOLLOW:
        followUserHandler?.(
          action.payload as ProfileDispatcherPayload<ProfileAction.ON_CLICK_TO_FOLLOW>
        );
        break;

      case ProfileAction.ON_CLICK_TO_UNFOLLOW:
        unfollowUserHandler?.(
          action.payload as ProfileDispatcherPayload<ProfileAction.ON_CLICK_TO_UNFOLLOW>
        );
        break;

      case ProfileAction.ON_CLICK_MY_DATA:
        showMyDataPage();
        break;

      default:
        break;
    }
  };
};

export default useActionsHandler;
